// extracted by mini-css-extract-plugin
module.exports = {"root":"Login_root__EHL7T","formWidthContainer":"Login_formWidthContainer__Kzo9C","oinq":"Login_oinq__ycCp3","oinqIn":"Login_oinqIn__3kdkb"};